module.exports = __webpack_public_path__ + "img/icon_tick@3x.23ce3b1c.png";